import {
    guid
} from "./helpers"

export const API_URL = window.API_URL
export const CLIENT_ROOT_URL = window.CLIENT_ROOT_URL
export const FOLDER = window.FOLDER

export const parametroEntity = () => {
    return {
        guid: guid(),
        nombre: '',
        descripcion: '',
        configuraciones: [parametroConfigEntity(1)]
    }
}

export const parametroConfigEntity = (posicion) => {
    return {
        guid: guid(),
        nombre: '',
        descripcion: '',
        posicion: posicion,
        selected: false,
    }
}

export const parametroDetalleEntity = (columnas, registro) => {
    const output = {
        registro: registro,
        selected: false
    }
    columnas.forEach(x => {
        output[x.get('id')] = {
            guid: guid(),
            id: null,
            updated: true,
            valor: '',
            parametro_id: x.get('parametro_id'),
            config_parametro_id: x.get('config_parametro_id')
        }
    })
    return output
}

export const distribucionSolicitudEntity = () => {
    return {
        guid: guid(),
        cenco: null,
        porcentaje: 0,
        _enabled: true,
    }
}

export const detalleSolicitudEntity = () => {
    return {
        guid: guid(),
        tipo_servicio: '',
        tipo_producto: '',
        menu: '',
        observaciones: '',
        valor_unitario: null,
        cantidad: null,
        subtotal: null,
        preaprobacion: '',
        _enabled: true,
    }
}

export const cencoEntity = () => {
    return {
        guid: guid(),
        codigo: '',
        nombre: '',
        unidad_negocio: '',
        activo: true,
        aprobador: null,
        presupuesto: [],
        presupuestos: [],
        users: [],
        _enabled: true,
    }
}

export const usuarioEntity = () => {
    return {
        guid: guid(),
        username: '',
        name: '',
        email: '',
        active: true,
        area: '',
        extension: '',
        roles: [],
        _enabled: true,
    }
}

export const tiposervicioEntity = () => {
    return {
        guid: guid(),
        nombre: '',
        tipos_producto: [],
        _enabled: true,
    }
}

export const presupuestoEntity = () => {
    return {
        guid: guid(),
        periodo: '',
        valor_total: null,
        valor_disponible: null,
        _enabled: true,
    }
}

export const tiposProductoEntity = () => {
    return {
        guid: guid(),
        nombre: '',
        descripcion: '',
        valor_maximo: null,
        valor_fijo: null,
        users: [],
        _enabled: true,
    }
}

export const plantillaEntity = () => {
    return {
        guid: guid(),
        nombre: '',
        texto: '',
        _enabled: true,
    }
}